module.exports = __webpack_public_path__ + "static/media/icon-client-service-circle.6cad4b93.svg";